import React, { Fragment } from "react";
import CustomInputField from "../../../../components/CustomHTMLElements/CustomInputField";
import CustomSelectDropdown from "../../../../NewComponents/CustomHTMLElements/CustomSelectDropdown";

export default function SignUpCorporate({
  countryCodes,
  allBanks,
  handleSubmitChange,
  genderData,
}) {
  return (
    <Fragment>
      <div className="col-md-6">
        <CustomInputField
          type="text"
          maxLength="30"
          label="Investor's First Name"
          placeholder="Rick"
          name="first_name"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6">
        <CustomInputField
          type="text"
          maxLength="30"
          label="Investor's Last Name"
          placeholder="Morty"
          name="last_name"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-12">
        <CustomInputField
          type="email"
          maxLength="128"
          name="email"
          placeholder="hello@ricknmorty.com"
          label="Email address"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6 mb-1">
        <CustomSelectDropdown
          name="country_code"
          label="Country"
          className="round user__form form-control"
          onChange={(e) => handleSubmitChange(e)}
        >
          <option value="">Choose Country</option>
          {countryCodes &&
            countryCodes.map((country, index) => {
              const { country_code, name } = country;
              return (
                <option value={country_code} key={index}>
                  {name}
                </option>
              );
            })}
        </CustomSelectDropdown>
      </div>
      <div className="col-md-6 mb-1">
        <CustomSelectDropdown
          name="gender"
          label="Gender"
          className="round user__form form-control"
          onChange={(e) => handleSubmitChange(e)}
        >
          <option value="">Choose Gender</option>
          {genderData &&
            genderData.map((gender, index) => {
              const { name } = gender;
              return (
                <option value={name} key={index}>
                  {name}
                </option>
              );
            })}
        </CustomSelectDropdown>
      </div>

      <div className="col-12">
        <CustomInputField
          type="email"
          maxLength="128"
          name="biz_email"
          placeholder="Rick and Morty Inc"
          label="Work Email"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6">
        <CustomInputField
          type="text"
          maxLength="128"
          name="biz_name"
          placeholder="Rick and Morty Inc"
          label="Business name"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>

      <div className="col-md-6">
        <CustomInputField
          type="number"
          name="rc_number"
          placeholder="Rick and Morty Inc"
          label="Registration Number"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6">
        <CustomInputField
          type="number"
          maxLength="20"
          name="phone_number"
          placeholder="07011111111"
          label="Investor Phone Number"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
      <div className="col-md-6">
        <CustomSelectDropdown
          name="bank_id"
          label="Bank"
          className="round user__form form-control"
          onChange={(e) => handleSubmitChange(e)}
        >
          <option value="">Choose Bank</option>
          {allBanks &&
            allBanks.map((bank, index) => {
              const { id, name } = bank;
              return (
                <option value={id} key={index}>
                  {name}
                </option>
              );
            })}
        </CustomSelectDropdown>
      </div>
      <div className="col-md-6">
        <CustomInputField
          type="number"
          maxLength="20"
          name="bank_account_number"
          placeholder=""
          label="Account Number"
          disableAutoComplete={true}
          onChange={(e) => handleSubmitChange(e)}
        />
      </div>
    </Fragment>
  );
}
